import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {TimelineLite} from "gsap";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborSoundManager} from "../../sound/PearlHarborSoundManager";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class PearlHarborFSResultPresentation implements FlowStatePresentation {
    private _tl:TimelineLite

    private completePresentation(flowStateController:FlowStateController) {
        flowStateController.finish();
    }

    public start(flowStateController:FlowStateController):void {
        this._tl = new TimelineLite();
        const delay: number = PearlHarbor.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? 1.5 : 3;

        this._tl.add(()=>{PearlHarborSoundManager.playMeterSpinStart();});
        this._tl.add([
            ()=>{PearlHarborSoundManager.playMeterSpinStop();},
            PearlHarbor.cocpitBoard.showWin()
        ], delay);
        this._tl.add(() => {
            PearlHarbor.cocpitBoard.updateBonusMeter();
            this.completePresentation(flowStateController);
        });
    }
}